export default __webpack_public_path__ + "static/media/712.7522d479.png";